import { newsArticles } from "../data/publishedArticleIndex.generated.js";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
const groups = [{
  title: "Projects & news",
  links: [["App portfolio", "/apps", "Original screenshots and previews from our published applications."], ["News", "/news", "Our articles and product updates, with their original dates."]]
}, {
  title: "Explore our services",
  links: [["Software", "/software", "Custom business applications, web apps, portals, and connected websites."], ["AI & Automation", "/ai-automation", "Company-knowledge assistants and practical workflow automation."]]
}, {
  title: "Get to know Karalewich",
  links: [["Home", "/", "A better way to run the everyday."], ["About", "/about", "Our approach, engineering background, and founder."], ["How we work", "/how-we-work", "From discovery to an ongoing development partnership."], ["Let’s talk", "/contact", "Start a conversation about your business."]]
}, {
  title: "Privacy & preferences",
  links: [["Privacy Policy", "/privacy", "How personal information is collected, used, and protected."]]
}];
groups.push({
  title: "Published articles",
  links: newsArticles.map(article => [article.title, `/news/${article.slug}`, `Originally published ${article.date}`])
});
export default function Sitemap() {
  return <main id="main" className="kw-sitemap-page">
      <section className="kw-page-hero">
        <span className="kw-eyebrow">FIND YOUR WAY</span>
        <h1>
          Explore
          <br />
          <span>Karalewich.</span>
        </h1>
        <p>
          Services, company information, and the next step for your business.
          Everything in one place.
        </p>
      </section>
      <nav className="kw-section kw-sitemap-directory" aria-label="Website sitemap">
        {groups.map(group => <section key={group.title}>
            <h2>{group.title}</h2>
            <div>
              {group.links.map(([label, path, description]) => <Link to={path} key={path}>
                  <div>
                    <h3>{label}</h3>
                    <p>{description}</p>
                  </div>
                  <ArrowUpRight size={21} />
                </Link>)}
            </div>
          </section>)}
      </nav>
      <div className="kw-sitemap-xml">
        <span>Looking for the search-engine sitemap?</span>
        <a href="/sitemap.xml">
          View XML sitemap <ArrowUpRight size={14} />
        </a>
      </div>
    </main>;
}
